(function() {
    'use strict';

    angular
        .module('adjustBenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','GLOBAL_URL'];

    function stateConfig($stateProvider,GLOBAL_URL) {
        $stateProvider.state('adjustben', {
            url: '/adjustben',
            data: {
                pageTitle: 'Điều chỉnh/ bổ sung người được thụ hưởng'
            },
            views: {
                'content@': {
                    templateUrl: GLOBAL_URL+'partial?uri=ga/adjustben/adjustben',
//                    templateUrl: GLOBAL_URL+'partial?uri=ga/pulse/pulse',
                    controller: 'AdjustBenController',
                    controllerAs: 'adjustBenCtrl'
                }
            }
        }).state('approve', {
            url: '/adjustben/:txnId/:taskId',
            data: {
                pageTitle: 'Thay đổi thông tin người được thụ hưởng'
            },
            params: { txnId: {squash: true, value: null }, taskId: {squash: true, value: null }},
            views : {
				'content@' : {
					templateUrl : GLOBAL_URL+'partial?uri=ga/adjustben/adjustben',
					controller: 'AdjustBenController',
					controllerAs:'adjustBenCtrl'
				}
			}
        }).state('adjustben1', {
            url: '/adjustben1/:policyNum',
            data: {
                pageTitle: 'Điều chỉnh/ bổ sung người được thụ hưởng'
            },
            params: { policyNum: {squash: true, value: null }},
            views: {
                'content@': {
                    templateUrl: GLOBAL_URL+'partial?uri=ga/adjustben/adjustben',
                    controller: 'AdjustBenController',
                    controllerAs: 'adjustBenCtrl'
                }
            }
        })
    }
})();
